import React from 'react';
import { AppCenteredLayout } from './../../Components/AppCenteredLayout';
import { Hangman } from './Components/Hangman';
import { Keyboard } from './Components/Keyboard';
import { InvisibleButton } from './Components/InvisibleButton';
import { Confetti } from './Components/Confetti';
import { LazyP5Sketch } from '../../Backgrounds/LazyP5Sketch';
import { noiseWaveSketch } from './../../Backgrounds/noiseWaveSketch';
import { yep } from './../../Services/beenHereBefore';
import './Styles/LandingGame.css';

const FIRST_KEY_MILLIS = 2000;
const SKIP_MILLIS = 100;

/**
 * Component rendering a hangman guessing game, where
 * letters not yet guessed are displayed by numbers.
 * Also offers a visible keyboard for letter input.
 *
 * Optional props:
 * - secret: the secret to be guessed. default 'davidvandenbogaerde'
 * - alphabet: letters that the game will look for. default 'abcdefghijklmnopqrstuvwxyz'
 * - keyboard: array of strings that define keyboard layout. default ['qwertyuiop', 'asdfghjkl', 'zxcvbnm']
 * - displayEnds: if true, first and last letter are shown and not considered part of the secret. default true
 */
export class LandingGame extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keysPressed: [],
      correctGuesses: [],
      showSkip: true,
      done: false
    };
    this.BG = LazyP5Sketch(noiseWaveSketch);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown, false);
    this.timeout = setTimeout(this.pressFirstKey, FIRST_KEY_MILLIS);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, false);
    clearTimeout(this.timeout);
    clearTimeout(this.checkDoneTimeOut);
  }

  render() {
    const confetti = this.state.done ? (
      <Confetti
        confettiDone={this.confettiDone}
        relPos={{ x: 0.5, y: 0.35 }}
        fadeToColor={{ r: 37, g: 37, b: 38 }}
      />
    ) : (
      undefined
    );
    return (
      <div>
        {/** dirty little sketch pre-loading trick here... */}
        {this.BG}
        <AppCenteredLayout styles="LandingGame">
          <Hangman
            correctGuesses={this.state.correctGuesses}
            secret={this.props.secret}
            displayEnds={this.props.displayEnds}
          />
          <Keyboard
            keysPressed={this.state.keysPressed}
            keyboard={this.props.keyboard}
            handleKeyPress={this.handleKeyPress}
          />
          <InvisibleButton
            click={this.skipThisThing}
            show={this.state.showSkip}
            text="ain't nobody got time for this"
          />
        </AppCenteredLayout>
        {confetti}
      </div>
    );
  }

  handleKeyDown = event => {
    const key = event.key.toLowerCase();
    this.handleKeyPress(key);
  };

  handleKeyPress = key => {
    this.setState((prevState, props) => {
      // ignore non-alphabet keys & repeat strokes
      if (
        !props.alphabet.includes(key) ||
        prevState.keysPressed.includes(key)
      ) {
        return null;
      }
      prevState.keysPressed[prevState.keysPressed.length] = key;
      if (props.secret.includes(key)) {
        prevState.correctGuesses[prevState.correctGuesses.length] = key;
      }
      return prevState;
    });

    // we're making sure the state change has had the time yet to be processed
    // before we check if the game's done or not.
    // apparently the order of execution is inconsistent between keydown & touch events
    clearTimeout(this.checkDoneTimeOut);
    this.checkDoneTimeOut = setTimeout(this.checkIfDone);
  };

  checkIfDone = () => {
    // check if we're done or not
    var leftovers = this.props.secret.split('').filter(c => {
      return !this.state.correctGuesses.includes(c);
    });
    if (!leftovers || leftovers.length === 0) {
      this.gameFinished();
    }
  };

  gameFinished = () => {
    if (this.state.showSkip) {
      this.setState({ showSkip: false });
    }
    if (this.state.done) {
      return;
    }
    this.setState({ done: true });
    yep();
  };

  confettiDone = () => {
    this.props.navigate('/about');
  };

  pressFirstKey = () => {
    if (this.state.keysPressed.length > 0) {
      return;
    }
    this.pressNextKey();
  };

  pressNextKey = () => {
    let todo = [];
    const done = this.state.correctGuesses;
    const from = this.props.secret.split('');

    todo = from.filter(letter => {
      return !done.includes(letter);
    });
    if (todo.length === 0) {
      clearInterval(this.interval);
      return;
    }
    this.handleKeyPress(todo[this.randomInt(todo.length)]);
  };

  randomInt = max => {
    return Math.floor(Math.random() * Math.floor(max));
  };

  skipThisThing = () => {
    this.interval = setInterval(this.pressNextKey, SKIP_MILLIS);
    this.setState({ showSkip: false });
  };
}

LandingGame.defaultProps = {
  secret: 'davidvandenbogaerde',
  alphabet: 'abcdefghijklmnopqrstuvwxyz',
  keyboard: ['qwertyuiop', 'asdfghjkl', 'zxcvbnm'],
  displayEnds: true
};
